__webpack_require__.p = "/QuoteGenerator/";